import { Component, Input, Output, EventEmitter, ChangeDetectorRef, AfterViewInit } from '@angular/core';
import { NgForm } from '@angular/forms';
import * as uuid from 'uuid';

@Component({
  selector: 'sd-radio-control',
  templateUrl: './radio-control.component.html',
  styleUrls: ['../../assets/css/label.scss', './radio-control.component.css']
})
export class RadioControlComponent implements AfterViewInit {
  private initialized = false;
  private pModel: any;
  private pItems: any[] = [];
  name = uuid.v4();
  @Input() valueField = 'value';
  @Input() displayField = 'display';
  @Input() display: 'row' | 'column' = 'row';

  @Input() form: NgForm;
  @Input() label: string;

  // tslint:disable-next-line: variable-name
  _items: any[] = [];
  get items(): any[] {
    return this._items;
  }
  @Input() set items(items: any[]) {
    if (!Array.isArray(items)) {
      items = [];
    }
    this.pItems = items;
    if (this.initialized) {
      this.onChanges();
    }
  }

  @Input() set model(value: any) {
    this.pModel = value || '';
    if (this.initialized) {
      this.onChanges();
    }
  }
  // Optional
  @Input() required = false;
  @Input() disabled = false;

  @Output() modelChange = new EventEmitter();
  // tslint:disable-next-line: no-output-native
  @Output() change = new EventEmitter();
  @Output() sdChange = new EventEmitter();

  constructor(private ref: ChangeDetectorRef) { }

  // tslint:disable-next-line: variable-name
  _model: any;
  // @ViewChild('formModel') formModel: NgModel;

  ngAfterViewInit() {
    this.onChanges();
    this.initialized = true;
    this.ref.detectChanges();
  }

  onChange(value: any) {
    this._model = value;
    this.modelChange.emit(this._model);
    this.change.emit(this._model);
    this.sdChange.emit(this._model);
  }

  private onChanges = () => {
    this._items = this.pItems;
    this._model = this.pModel;
    if (!this._model && this.required && this._items.length > 0) {
      setTimeout(() => {
        this.onChange(this._items[0][this.valueField]);
      });
    }
  }
}
